import { styled } from '@mui/material';

const PREFIX = 'InviteUserLedger';

export const inviteUserLedgerClasses = {
  buttonGroup: `${PREFIX}-buttonGroup`,
  boldLabel: `${PREFIX}-boldLabel`,
};

export const InviteUserLedgerRoot = styled('form')(({ theme }) => ({
  [`& .${inviteUserLedgerClasses.buttonGroup}`]: {
    marginTop: theme.spacing(4),
    display: 'flex',
    justifyContent: 'flex-end',
  },

  [`& .${inviteUserLedgerClasses.boldLabel}`]: {
    fontWeight: 600,
    color: theme.palette.text.secondary,
    margin: theme.spacing(1, 0),
  },
}));
